import React from "react";
import { motion } from "framer-motion";
import { BookOpen, Search, ShieldCheck, Globe } from "lucide-react";
import "../App.css"; // custom CSS file
import Navbar from "../componenets/Navbar";
import Footer from "../componenets/Footer";

// About page for Sri Lanka Tariff Search Engine
// Theme: light blue / dark blue with custom CSS overrides

export default function AboutPage() {
  return (
    <div>
      <Navbar />
    <div className="about-page">
      <div className="about-container">
        <header className="about-header">
          <div className="about-brand">
            <div className="about-logo">
              <BookOpen className="icon-white" />
            </div>
            <div>
              <h1 className="about-title">Sri Lanka Tariff Search Engine</h1>
              <p className="about-subtitle">Instant access to Sri Lanka Customs tariff data (NITG 2025)</p>
            </div>
          </div>
          <div>
            <span className="about-version">Version 2025</span>
          </div>
        </header>

        <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
          <div className="about-card">
            <h2 className="about-section-title">What this tool does</h2>
            <p className="about-text">
              The Sri Lanka Tariff Search Engine gives businesses, customs brokers, researchers, and policy makers fast, searchable access to tariff lines
              from the official Sri Lanka Customs National Imports Tariff Guide (NITG) — based on the 2025 edition effective from <strong>19 June 2025</strong>.
            </p>
          </div>

          <div className="about-grid">
            <div className="about-card">
              <div className="about-icon-text">
                <Search className="about-icon" />
                <div>
                  <h3 className="about-card-title">Search & Filter</h3>
                  <p className="about-card-text">Search by HS code or keyword. Filter results by chapter, duty type or levy (CD, VAT, PAL, Excise, CESS, SSCL, SCL).</p>
                </div>
              </div>
            </div>

            <div className="about-card">
              <div className="about-icon-text">
                <ShieldCheck className="about-icon" />
                <div>
                  <h3 className="about-card-title">Detailed Tax Breakdown</h3>
                  <p className="about-card-text">View preferential and general duty columns, sub-headers (AP/IN/SA/SG/etc.), PAL and CESS options, and luxury tax where applicable.</p>
                </div>
              </div>
            </div>

            <div className="about-card">
              <div className="about-icon-text">
                <Globe className="about-icon" />
                <div>
                  <h3 className="about-card-title">Preferential Rates</h3>
                  <p className="about-card-text">Includes preferential duty columns for trade agreements such as APTA, SAFTA, Indo–Sri Lanka FTA and others.</p>
                </div>
              </div>
            </div>

            <div className="about-card">
              <div className="about-icon-text">
                <BookOpen className="about-icon" />
                <div>
                  <h3 className="about-card-title">Source & Accuracy</h3>
                  <p className="about-card-text">Data is extracted from the official NITG 2025 PDF. This tool is a reference aid — always verify critical information with Sri Lanka Customs and gazette notices.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-card">
            <h2 className="about-section-title">How to use</h2>
            <ol className="about-list">
              <li>Enter a full or partial <strong>HS code</strong> or a product keyword (e.g., "motor", "tea").</li>
              <li>Use the filters to narrow results: chapter, duty type, or trade preference.</li>
              <li>Click a tariff line to view the complete breakdown and page reference to NITG (page numbers included).</li>
            </ol>
          </div>

          <div className="about-card">
            <h2 className="about-section-title">Disclaimer</h2>
            <p className="about-disclaimer">
              This search engine is provided as a convenience and is based on the Sri Lanka Customs "National Imports Tariff Guide - 2025" (effective 19 June
              2025). While we strive for accuracy, the official legal sources (Acts, gazette notifications and Sri Lanka Customs) are the final authority.
              Users should confirm tariff rates and statutory requirements with Sri Lanka Customs before making trade or compliance decisions.
            </p>

            <div className="about-buttons">
              <a href="/contact" className="btn-primary">View Source PDF</a>
              <a href="https://www.customs.gov.lk/" className="btn-outline">Contact Customs</a>
            </div>
          </div>
        </motion.div>

        <footer className="about-footer">
         
        </footer>
      </div>
    </div>
    <Footer/>
    </div>
  );
}
